import { TaskViewElementEnum } from "@/components/tasks-kanban/enums";

export class TaskColumnModel {
  /**Тип элемента */
  Type!: TaskViewElementEnum;
  /**Имя */
  Name!: string;
  /**Ширина элемента */
  Width!: string;
  /**Минимальная ширина элемента */
  MinWidth!: string;
  /**Минимальная ширина элемента */
  MaxWidth!: string;
  /**Выравнивание */
  Align: "left" | "center" | "right" = "left";
  /**Иконка */
  Icon?: any;

  constructor(obj?: Partial<TaskColumnModel>) {
    Object.assign(this, obj);
  }
}
